<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Evolución de Evaluación de Desempeño</h6>
                </v-card-title>
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="listado" group-by="gerencia" locale="es-ar"
                        class="elevation-1" :items-per-page="500" hide-default-footer>
                        <template v-slot:header.puntaje1="{ header }">
                            Valor año {{ periodoanterior }}
                        </template>
                        <template v-slot:header.puntaje2="{ header }">
                            Valor año {{ periodo }}
                        </template>
                        <template v-slot:group.header="{ items }">
                            <td :colspan="headers.length" class="text-xs-right" style="color: green;">
                                <strong>{{ items[0].gerencia }}</strong>
                            </td>
                        </template>
                        <!-- <template v-slot:group.header="{ items }">
                            <td class="text-xs-right" style="color: green;">
                                <strong>{{ items[0].gerencia }}</strong>
                            </td>
                        </template> -->
                        <template v-slot:group.summary="{ group, items }">
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                            <td>
                                <h6><b> {{ subTotal(items, 'puntaje1').toFixed(2) }}</b></h6>
                            </td>
                            </th>
                            <th>
                            <td>
                                <h6><b>{{ subTotal(items, 'puntaje2').toFixed(2) }}</b></h6>
                            </td>
                            </th>
                            <th>
                            <td>
                                <h6><b>{{ subTotal(items, 'puntaje3').toFixed(3) }}</b></h6>
                            </td>
                            </th>
                        </template>
                        <template slot="body.append">
                            <tr>
                                <th>
                                    <h6><b>PROMEDIO TOTAL</b></h6>
                                </th>
                                <th>-</th>
                                <th>-</th>
                                <th>
                                    <h6><b>{{ promtotalant.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ promtotalpres.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ porcentaje.toFixed(3) }}</b></h6>
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6><b>PROMEDIO NIVEL RESPONSABLE</b></h6>
                                </th>
                                <th>-</th>
                                <th>-</th>
                                <th>
                                    <h6><b>{{ promrespant.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ promresppres.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ porcentajeresp.toFixed(3) }}</b></h6>
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6><b>PROMEDIO NIVEL OPERATIVO</b></h6>
                                </th>
                                <th>-</th>
                                <th>-</th>
                                <th>
                                    <h6><b>{{ promoperant.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ promoperpres.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ porcentajeoper.toFixed(3) }}</b></h6>
                                </th>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-app>
    </div>
</template>

<style scoped>
.v-data-table__group.summary {
    display: none;
}
</style>
<script>
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
export default {

    data: (vm) => ({

        filtrocodgral: "",
        filtromes: "",
        filtroresponsable: "",
        filtroobserv: "",
        listadoequipo: [],
        date: new Date().toISOString().substr(0, 7),
        datehoy: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        listado: [],
        promtotalant: 0,
        promtotalpres: 0,
        promrespant: 0,
        promresppres: 0,
        porcentaje: 0,
        porcentajeresp: 0,
        promoperant: 0,
        promoperpres: 0,
        porcentajeoper: 0,
        evoluciontotalant: 0,
        evoluciontotalpres: 0,
        evolucionrespant: 0,
        evolucionresppres: 0,
        evolucionoperant: 0,
        evolucionoperpres: 0,
        cantidadtotal: 0,
        cantidadresp: 0,
        cantidadoper: 0,
        periodo: moment().subtract(1, "year").year(),
        periodoanterior: moment().subtract(2, "year").year(),

        headers: [
            {
                text: "Gerencia",
                align: "start",
                sortable: false,
                value: "gerencia",
                width: "25%"
            },
            { text: "", value: "", width: "10%" },
            { text: "Legajo", value: "legajo", width: "10%" },
            { text: "Nombre", value: "nombre", width: "25%" },
            { text: "valor año anterior", value: "puntaje1", width: "10%" },
            { text: "Valor año actual", value: "puntaje2", width: "10%" },
            { text: "Evolución", value: "puntaje3", width: "10%" },

        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        subTotal(items, column) {
            const validItems = items.filter(item => item[column] != null && item[column] !== "" && !isNaN(parseFloat(String(item[column]).replace(',', '.'))));
            if (validItems.length === 0) return 0;
            const total = validItems.reduce((sum, item) => sum + parseFloat(String(item[column]).replace(',', '.')), 0);
            const average = total / validItems.length;
            return isNaN(average) ? 0 : average;
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month] = date.split("-");
            return `${month}/${year}`;
        },

        cargarListados() {
            this.vaciarModels();

            let self = this;

            axios
                .get("/RRHH/ListadoEvolucionDesemp?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.evoluciontotalant = 0;
                    self.evoluciontotalpres = 0;
                    self.evolucionrespant = 0;
                    self.evolucionresppres = 0;
                    self.evolucionoperant = 0;
                    self.evolucionoperpres = 0;
                    self.promtotalant = 0;
                    self.promtotalpres = 0;
                    self.porcentaje = 0;
                    self.cantidadtotal = 0;
                    self.promrespant = 0;
                    self.promresppres = 0;
                    self.porcentajeresp = 0;
                    self.cantidadresp = 0;
                    self.promoperant = 0;
                    self.promoperpres = 0;
                    self.porcentajeoper = 0;
                    self.cantidadoper = 0;
                    // Filtrar: solo mostrar personas que tengan valor en ambos periodos
                    self.listado = response.data.filter(item => {
                        const v1 = parseFloat(String(item.puntaje1 || '0').replace(',', '.')) || 0;
                        const v2 = parseFloat(String(item.puntaje2 || '0').replace(',', '.')) || 0;
                        return v1 > 0 && v2 > 0;
                    });
                    for (let i = 0; i < self.listado.length; i++) {
                        const p1 = parseFloat(String(self.listado[i].puntaje1 || '0').replace(',', '.')) || 0;
                        const p2 = parseFloat(String(self.listado[i].puntaje2 || '0').replace(',', '.')) || 0;
                        if (p1 > 0 && p2 > 0) {
                            self.evoluciontotalant += p1;
                            self.evoluciontotalpres += p2;
                            self.cantidadtotal += 1;
                            if (self.listado[i].tipo == "R") {
                                self.evolucionrespant += p1;
                                self.evolucionresppres += p2;
                                self.cantidadresp += 1;
                            }
                            if (self.listado[i].tipo == "O") {
                                self.evolucionoperant += p1;
                                self.evolucionoperpres += p2;
                                self.cantidadoper += 1;
                            }
                        }
                    }
                    self.promtotalant = self.cantidadtotal > 0 ? self.evoluciontotalant / self.cantidadtotal : 0;
                    self.promtotalpres = self.cantidadtotal > 0 ? self.evoluciontotalpres / self.cantidadtotal : 0;
                    self.porcentaje = self.promtotalant > 0 ? self.promtotalpres / self.promtotalant : 0;

                    self.promrespant = self.cantidadresp > 0 ? self.evolucionrespant / self.cantidadresp : 0;
                    self.promresppres = self.cantidadresp > 0 ? self.evolucionresppres / self.cantidadresp : 0;
                    self.porcentajeresp = self.promrespant > 0 ? self.promresppres / self.promrespant : 0;

                    self.promoperant = self.cantidadoper > 0 ? self.evolucionoperant / self.cantidadoper : 0;
                    self.promoperpres = self.cantidadoper > 0 ? self.evolucionoperpres / self.cantidadoper : 0;
                    self.porcentajeoper = self.promoperant > 0 ? self.promoperpres / self.promoperant : 0;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>